<template>
  <!-- <layout-vertical :nav-menu-items="moduleResults"> -->
  <layout-vertical :nav-menu-items="filteredNavMenu">
    <router-view />

    <app-customizer v-if="showCustomizer" slot="customizer" />
  </layout-vertical>
</template>

<script>
import LayoutVertical from "@core/layouts/layout-vertical/LayoutVertical.vue";
import AppCustomizer from "@core/layouts/components/app-customizer/AppCustomizer.vue";
import { $themeConfig } from "@themeConfig";
import navMenuItems from "@/navigation/vertical";
import { filterNavigation } from "@/security/navigation/navigationFilter";

export default {
  components: {
    AppCustomizer,
    LayoutVertical,
  },
  data() {
    return {
      showCustomizer: $themeConfig.layout.customizer,
      navMenuItems,
      // optMenuItems: [],
      // moduleResults: [],
    };
  },
  computed: {
    filteredNavMenu() {
      return filterNavigation(this.navMenuItems);
    },
  },
  watch: {
    // "$store.state.appConfig.menuPermissions"(menu) {
    //   if (menu && Array.isArray(menu)) {
    //     this.optMenuItems = menu;
    //     // Comparar optMenuItems con navMenuItems y guardar coincidencias
    //     this.compareMenuItems();
    //   }
    // },
  },
  mounted() {
    // // Inicializar optMenuItems con el valor del store si ya existe
    // const menuFromStore = this.$store.state.appConfig.menuPermissions;
    // if (menuFromStore && Array.isArray(menuFromStore)) {
    //   this.optMenuItems = menuFromStore;
    // }
    // // Comparar optMenuItems con navMenuItems y guardar coincidencias
    // this.compareMenuItems();
  },

  methods: {
    compareMenuItems() {
      const optItems = this.optMenuItems || [];
      const navItems = this.navMenuItems || [];

      // Encontrar coincidencias por title y name
      const coincidencias = navItems.filter((navItem) => {
        return optItems.some((optItem) => {
          // Validar que ambos propiedades existan antes de comparar
          const optName = optItem?.nameModule?.trim();
          const navTitle = navItem?.name?.trim();

          if (optName && navTitle) {
            return navTitle.toLowerCase() === optName.toLowerCase();
          }
          return false;
        });
      });

      // Guardar coincidencias en moduleResults
      this.moduleResults = coincidencias;
    },
  },
};
</script>
